export const counterPartiesMapper = {
  JPMS: 'sg-cp-jpm',
  JPMSGP: 'sg-cp-jpm',
  BUX: 'sg-cp-bux-color',
  SQB: 'sg-cp-swissquote-color',
  FREETD: 'sg-cp-freetrade-color',
  GVCVAL: 'sg-cp-gvc',
  L3099: 'sg-cp-gvc',
  L3355: 'sg-cp-gvc',
  L3098: 'sg-cp-gvc',
  L3097: 'sg-cp-gvc',
  L3542: 'sg-cp-gvc',
  MSINT: 'sg-cp-morgan-stanley-color',
  MSCO: 'sg-cp-morgan-stanley-color',
  MSINTFI: 'sg-cp-morgan-stanley-color',
  ZKB: 'sg-cp-zkb-color',
  BCSL: 'sg-cp-barclays-color',
  BBPLC: 'sg-cp-barclays-color',
  BBPLCNY: 'sg-cp-barclays-color',
  UBS: 'sg-cp-ubs-color',
  UBSLLC: 'sg-cp-ubs-color',
  CITIEQ: 'sg-cp-citi',
  CITIUS: 'sg-cp-citi',
  BAML: 'sg-cp-bank-of-america',
  SCOTIA: 'sg-cp-bank-of-nova-scotia-color',
  BFFALI01: 'sg-cp-bff',
  BFFALI02: 'sg-cp-bff',
  BFFALI03: 'sg-cp-bff',
  BFFALI04: 'sg-cp-bff',
  BFFALI05: 'sg-cp-bff',
  BFFALI06: 'sg-cp-bff',
  BFFALI07: 'sg-cp-bff',
  BFFALI08: 'sg-cp-bff',
  BFFALI09: 'sg-cp-bff',
  BFFCON01: 'sg-cp-bff',
  BFFCON02: 'sg-cp-bff',
  SANT: 'sg-cp-santander-color',
  MORABANC: 'sg-cp-moraBanc-color',
  MORABC: 'sg-cp-moraBanc-color',
};
